// client/src/routes/app/properties/index.tsx — SCR-PROP-001 · PROP-004 (04 §8.3).
//
// Replaces UI-003's `PlaceholderScreen`, which was here so that its "all V1 module routes exist
// in the sidebar, may point to placeholder pages" criterion would be literally true, and which
// named this item as its owner.
//
// The route owns the URL state and nothing else: `validateSearch` runs the §9.2.3 schema, and
// the screen reads it back typed. Filters therefore survive refresh, are shareable, and Back is
// a filter-undo — the mechanism `routes/demo.tsx` demonstrates.
//
// The `Portfolio.Read` guard is UI-003's and stays: the sidebar hides the entry, and this
// renders SCR-SYS-403 for the URL that was typed anyway (§9.2.2).

import { createFileRoute, useNavigate } from '@tanstack/react-router';

import { RequirePermission } from '@/components/layout/route-guards';
import { PropertyList } from '@/features/properties/PropertyList';
import { propertySearchSchema, type PropertySearch } from '@/features/properties/search';

export const Route = createFileRoute('/app/properties/')({
  validateSearch: propertySearchSchema,
  component: PropertiesScreen,
});

function PropertiesScreen() {
  const search = Route.useSearch();
  const navigate = useNavigate({ from: Route.fullPath });

  return (
    <RequirePermission permission="Portfolio.Read">
      <PropertyList
        search={search}
        onSearchChange={(next: (previous: PropertySearch) => PropertySearch) => {
          void navigate({ search: next });
        }}
      />
    </RequirePermission>
  );
}
